export default function SimpleWishlistModal({
  lang, darkMode,
  simpleWishlistName, setSimpleWishlistName,
  setShowSimpleWishlistModal, confirmSimpleWishlist,
}) {
  return (
    <div className="modal-overlay" onClick={function(e) { if (e.target === e.currentTarget) setShowSimpleWishlistModal(false); }}>
      <div className="modal">
        <h3 style={{ fontFamily: "Playfair Display, serif", fontSize: 18, marginBottom: 16 }}>
          {lang === "es" ? "Nueva Wishlu" : lang === "fi" ? "Uusi Wishlu" : "New Wishlu"}
        </h3>
        <div className="campo">
          <label className="campo-label">
            {lang === "es" ? "Nombre de tu nueva Wishlu" : lang === "fi" ? "Wishlu'n nimi" : "Name your new Wishlu"}
          </label>
          <input
            className="campo-input"
            placeholder={lang === "es" ? "ej. Mi lista de navidad 🎄" : lang === "fi" ? "esim. Joulutoiveeni 🎄" : "e.g. My Christmas list 🎄"}
            value={simpleWishlistName}
            onChange={function(e) { setSimpleWishlistName(e.target.value); }}
            onKeyDown={function(e) { if (e.key === "Enter") confirmSimpleWishlist(); }}
            autoFocus
          />
        </div>
        <button className="btn btn-dorado btn-full" onClick={confirmSimpleWishlist} style={{ marginBottom: 8 }}>
          {lang === "es" ? "Crear Wishlu" : lang === "fi" ? "Luo Wishlu" : "Create Wishlu"}
        </button>
        <button className="btn btn-gris btn-full" onClick={function() { setShowSimpleWishlistModal(false); }}>
          {lang === "es" ? "Cancelar" : lang === "fi" ? "Peruuta" : "Cancel"}
        </button>
      </div>
    </div>
  );
}
